import { dashboardService } from "@/api/services/dashboardService";
import { DashboardApiMetricWidget } from "../dashboardLeafWidgets";

type Data = Record<string, any>;

/** 用户转化分析，保留旧接口统计字段。 */
export default function CustomerConvertAnalysis() {
    return (
        <DashboardApiMetricWidget<Data>
            title="用户转化分析"
            load={value => dashboardService.getCustomerConvertAnalysis(value as never)}
            metrics={[
                { label: "注册用户", key: "totalRegisterNum", unit: "人" },
                { label: "采购商", key: "totalRegisterCustomerNum", unit: "人" },
                { label: "承运商", key: "totalRegisterCarrierNum", unit: "人" },
                { label: "个人认证", key: "totalPersonalCertificationNum", unit: "人" },
                { label: "组织机构认证", key: "totalOrganizationCertificationNum", unit: "家" }
            ]}
        />
    );
}
